import withAPIAction from 'utils/withAPIAction'
import {
  getDataListAction,
  createDataAction,
  updateDataAction,
  getCountTypeListAction,
} from './actions'
import {
  ChecklistConfigTypeDetailReq,
  ChecklistSVCountTypeListReq,
  GetDataListReq,
} from './types'
import { verifyReq } from 'utils/verify'

export const onGetCountTypeList = (
  token: string,
  data: ChecklistSVCountTypeListReq
) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<ChecklistSVCountTypeListReq>({
    method: 'POST',
    path: 'GetChecklistSVCountTypeList',
    data,
    token: `Bearer ${token}`,
  })(getCountTypeListAction)
}

export const onGetChecklistTypeConfigList = (
  token: string,
  data: GetDataListReq
) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<GetDataListReq>({
    method: 'POST',
    path: 'GetChecklistTypeConfigList',
    data,
    token: `Bearer ${token}`,
  })(getDataListAction)
}

export const onCreateChecklistTypeConfig = (
  token: string,
  data: ChecklistConfigTypeDetailReq
) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<ChecklistConfigTypeDetailReq>({
    method: 'POST',
    path: 'CreateChecklistTypeConfig',
    data,
    token: `Bearer ${token}`,
  })(createDataAction)
}

export const onUpdateChecklistTypeConfig = (
  token: string,
  data: ChecklistConfigTypeDetailReq
) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<ChecklistConfigTypeDetailReq>({
    method: 'POST',
    path: 'UpdateChecklistTypeConfig',
    data,
    token: `Bearer ${token}`,
  })(updateDataAction)
}
